import { Trans } from "@lingui/macro";

import {
  selectTradeboxSwapAmounts,
  selectTradeboxToToken,
  selectTradeboxTradeFlags,
} from "context/SyntheticsStateContext/selectors/tradeboxSelectors";
import { useSelector } from "context/SyntheticsStateContext/utils";
import { applySlippageToMinOut } from "domain/synthetics/trade";
import { formatBalanceAmount } from "lib/numbers";

import { SyntheticsInfoRow } from "components/SyntheticsInfoRow";

export function MinReceiveRow({ allowedSlippage }: { allowedSlippage: number }) {
  const { isMarket, isSwap } = useSelector(selectTradeboxTradeFlags);
  const swapAmounts = useSelector(selectTradeboxSwapAmounts);

  const toToken = useSelector(selectTradeboxToToken);

  if (!isSwap || swapAmounts?.minOutputAmount === undefined || !toToken) {
    return null;
  }

  // For both directions, display the on-chain minimum after slippage.
  // "from": minOutputAmount is the expected output, slippage reduces it
  // "to": minOutputAmount is inflated so that after slippage it equals the desired amount
  const displayMinReceive = isMarket
    ? applySlippageToMinOut(allowedSlippage, swapAmounts.minOutputAmount)
    : swapAmounts.minOutputAmount;

  return (
    <SyntheticsInfoRow label={<Trans>Minimum receive</Trans>} valueClassName="numbers break-all !whitespace-normal">
      {formatBalanceAmount(displayMinReceive, toToken.decimals, toToken.symbol, {
        isStable: toToken.isStable,
      })}
    </SyntheticsInfoRow>
  );
}
